// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

// Created by Weverton Couto
// on 23/10/2025
// for Techmatic Solutions
// using Odoo 17.0

import React from 'react';
import ChartistGraph from "react-chartist";

const GraficoLinha12Meses = ({ dados }) => {
    if (!dados || !dados.meses || dados.meses.length === 0) {
        return (
            <div className="chart-card">
                <h3 className="chart-title">Envios nos Últimos 12 Meses</h3>
                <div className="empty-state">
                    <div className="empty-state-icon">
                        <i className="fas fa-chart-line"></i>
                    </div>
                    <p className="empty-state-title">Nenhum dado disponível</p>
                    <p className="empty-state-text">Não há mensagens para exibir neste período</p>
                </div>
            </div>
        );
    }

    const chartData = {
        labels: dados.meses.map(item => item.mes),
        series: [
            dados.meses.map(item => item.total)
        ]
    };

    const maxValue = Math.max(...dados.meses.map(m => m.total), 1);
    
    const chartOptions = {
        lineSmooth: true,
        low: 0,
        high: maxValue * 1.1,
        chartPadding: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 20
        },
        axisX: {
            showGrid: false,
            showLabel: true,
            offset: 20
        },
        axisY: {
            showGrid: true,
            showLabel: true,
            offset: 40,
            onlyInteger: true
        },
        showPoint: true,
        pointSize: 6
    };

    const chartType = 'Line';

    return (
        <div className="chart-card">
            <h3 className="chart-title">Envios nos Últimos 12 Meses</h3>
            <div className="chart-container">
                <ChartistGraph
                    data={chartData}
                    options={chartOptions}
                    type={chartType}
                />
            </div>
        </div>
    );
};

export default GraficoLinha12Meses;

